import styled from 'styled-components'
import { media } from '../../../utils/mediaQuery'

export const Container = styled.div`
  position: relative;
  margin-bottom: 24px;
`

export const Content = styled.div`
  margin-left: 100px;
  padding-top: 0;

  ${media.tabletDown} {
    margin-left: 0;
  }
`
